const sortColumn = (data, columnName, order) => {
console.log(data, columnName, order);
    if (data?.length === 0 || columnName?.length === 0 || isNaN(order) === true)
        return []
    

    let sortedData = data.slice().sort((a, b) => {
        if(a[columnName] < b[columnName])
            return -1
    })

    if (order === -1) {
        return sortedData.reverse()    
    }

    return sortedData
}

export default sortColumn